// extracted by mini-css-extract-plugin
export default {"search":"styles_search__cRT0a","searchText":"styles_searchText__HGtDk"};